export default "__VITE_ASSET__BW54I0d7__"